import { BaseEntity } from 'yt-ng-framework';

export class PravoNaGoView extends BaseEntity {
  constructor() {
      super();
  }
  OrgJed: string = null;
  Osoba: string = null;
  ObrazacZaGo: string = null;
  Godina: number = null;


  Deserialize(input: any) {
      this.ID = input.ID;
      this.OrgJed = input.OrgJed;
      this.ObrazacZaGo = input.ObrazacZaGo;
      this.Osoba = input.Osoba;
      this.Godina = input.Godina;
      return this;
  }

  Serialize(input: PravoNaGoView) {
      return input;
  }
}
